<!-- Path: libs/core/shell/src/lib/layout/admin/components/shell-admin-header/shell-admin-header.component.html -->
<header class="shell__header">
  <div class="shell__header-left">
    @if (headerUpperTitle) {
      <span class="shell__eyebrow">
        {{ headerUpperTitle }}
      </span>
    }

    @if (breadcrumbs.length) {
      <lib-ui-breadcrumb
        class="shell__breadcrumb"
        [items]="breadcrumbs"
      ></lib-ui-breadcrumb>
    }

    @if (headerTitle || addActionLabel) {
      <div class="shell__title-row">
        @if (headerTitle) {
          <h2 class="shell__title">
            {{ headerTitle }}
          </h2>
        }
      </div>
    }

    @if (headerSubtitle) {
      <p class="shell__subtitle">
        {{ headerSubtitle }}
      </p>
    }
  </div>

  <div class="shell__header-right">
    @if (hasAddAction()) {
      <ui-button
        class="shell__add-action"
        size="sm"
        type="button"
        [routerLink]="addActionRoute"
      >
        {{ addActionLabel }}
      </ui-button>
    }

    <ng-content select="[shellAdminHeaderActions]"></ng-content>
  </div>
</header>